import { IBenchConsultant } from "../../models/BenchConsultant"

export const EmptyBenchConsultant: IBenchConsultant = {
    consultant_Name: "",
    phone: "",
    job_Titles: "",
    email: "",
    visa: 0,
    state: {
        state_ID: 0,
        state_Name: ""
    },
    city: {
        city_ID: 0,
        city_Name: ""
    },
    rate: 0,
    f2F: "",
    marketing_Status: "",
    marketing_Priority: "",
    recruiter_ID: 0,
    consultant_Type: "",
    comment: "",
    sub_Vendor_Company: "",
    contact_Person_Name: ""
}